import * as FormsApiService from '../Common/Services/FormsApiService';


export const getFormTemplates = (companyId, employeeId, formTypeId) => {
  return async dispatch => {
    return await FormsApiService.getFormTemplates(companyId, employeeId, formTypeId);
  }
};

export const launchFormInstance = (companyId, employeeId, formInstance) => {
  return async dispatch => {
    return await FormsApiService.launchFormInstance(companyId, employeeId, formInstance);
  }
};

export const getFormInstance = (companyId, employeeId, instanceId, includeParticipants) => {
  return async dispatch => {
    return await FormsApiService.getFormInstance(companyId, employeeId, instanceId, includeParticipants);
  }
};

export const getFormInstanceWithConfidentiality = (companyId, employeeId, instanceId, includeParticipants, viewConfidentially) => {
  return async dispatch => {
    return await FormsApiService.getFormInstanceWithConfidentiality(companyId, employeeId, instanceId, includeParticipants, viewConfidentially);
  }
};